// extracted by mini-css-extract-plugin
export default {"paw":"spiner_paw__AkiFZ","spin":"spiner_spin__B+0Ys"};